module.exports = __webpack_public_path__ + "img/globish-space-logo@2x.ee9ac647.png";